const select =
{
    tooltip : 'Tout sélectionner'
};

export default select ;